/**
 * Stub for Parties endpoints.
 */
export interface IUserManagementEndpoints {
  getUserPermissions: () => string;
}

/**
 * User management endpoints
 * @param versionedUrl
 */
export const userManagementEndpoints = (versionedUrl: string): IUserManagementEndpoints => {
  const baseUrl = `${versionedUrl}user`;

  return {
    getUserPermissions: () => `${baseUrl}/permissionlist`
  }
}